module.exports = __webpack_public_path__ + "static/img/img_shebei_shouhuan.ec916272.png";